import type { ChartPeriod } from '@/features/(insight)/performance/performance-types';

export const chartPeriodToDayjsUnit = (period: ChartPeriod) => {
  switch (period) {
    case 'daily':
      return 'day';
    case 'weekly':
      return 'week';
    case 'monthly':
      return 'month';
  }
};
